import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CCModal from 'components/shared/DesignSystem/CCModal/CCModal';
import ProjectUsersIndex from './Index';
import { translate } from 'translations/i18n';

import { useDispatch } from 'react-redux';
import { fetchProject } from 'actions/projects';
import { Spinner } from '@companycam/slab-web';

// #region styled-components
const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const Title = styled.h2`
  margin: 0;
  font-size: var(--cc_size_text_xl);
  font-weight: 700;
`;

const Subtitle = styled.h3`
  margin-top: var(--cc_size_spacing_m);
  font-size: var(--cc_size_text_m);
  font-weight: 400;
  color: var(--cc_color_text_subtle);
`;

const StyledCCModal = styled(CCModal)`
  height: 75%;
  overflow-y: scroll;
`;
// #endregion

const ProjectUsersModal = ({
  onRequestClose,
  projectId,
  openToAssignUsers,
  projectTitle,
}) => {
  const [project, setProject] = useState(null);
  const projectName = projectTitle || project?.title;

  const dispatch = useDispatch();

  useEffect(() => {
    if (!projectTitle) {
      dispatch(fetchProject(projectId))
        .then((_project) => {
          setProject(_project);
        })
        .catch(() => {
          onRequestClose();
        });
    }
  }, [dispatch, onRequestClose, projectId, projectTitle]);

  const title = (
    <>
      <Title data-testid="project-users-modal__title">
        {translate('projects.users.title')}
      </Title>
      <Subtitle data-testid="project-users-modal__subtitle">
        {translate('projects.users.listItem.introPara', {
          projectName,
        })}
      </Subtitle>
    </>
  );

  return (
    <StyledCCModal
      size="medium"
      isOpen
      onRequestClose={onRequestClose}
      title={title}
      label={translate('projects.users.title')}
    >
      {projectName ? (
        <ProjectUsersIndex
          projectId={projectId}
          isModal
          openToAssignUsers={openToAssignUsers}
        />
      ) : (
        <LoaderContainer>
          <Spinner />
        </LoaderContainer>
      )}
    </StyledCCModal>
  );
};

ProjectUsersModal.propTypes = {
  onRequestClose: PropTypes.func,
  projectId: PropTypes.number,
  projectTitle: PropTypes.string,
  openToAssignUsers: PropTypes.bool,
};

export default ProjectUsersModal;
